export default __webpack_public_path__ + "static/segment-entry-exit-e2fda64a34cac9b031a273101a39fb06.png";